import { Link } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";
import { useAuth } from "../../context/auth";

// Non-intrusive sidebar upsell — never a blocking popup.
export default function PlusUpsell() {
  const { user } = useAuth();
  if (user?.plus) return null;
  return (
    <div data-testid="plus-upsell" className="rounded-xl border border-brand/25 bg-gradient-to-br from-brand/10 to-transparent p-5">
      <div className="flex items-center gap-2 text-sm font-bold text-brand">
        <Sparkles className="h-4 w-4" /> Guru Plus
      </div>
      <p className="mt-2 text-sm text-foreground/80">
        Compare scenarios side-by-side, export branded PDFs with charts, and see all your money in one dashboard.
      </p>
      <p className="mt-2 text-xs font-semibold text-brand">From $4.08/mo billed annually</p>
      <Link to="/guru-plus" data-testid="plus-upsell-cta"
        className="mt-3 inline-flex items-center gap-1.5 rounded-full bg-action px-4 py-2 text-xs font-semibold text-white transition-colors hover:bg-action-hover">
        Explore Guru Plus <ArrowRight className="h-3.5 w-3.5" />
      </Link>
    </div>
  );
}
